import React from "react";
import { useTranslation } from "react-i18next";
import Datatable from "components/Common/dataTable";
import { Payroll } from "../../../types/payrollTypes";
import { formatMoney } from "helpers/numberHelper";
import { formatToLocaleDate } from "utils/dateUtils";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import PayrollStatusBadge from "components/Common/Badge/PayrollStatusBadge";
import { all_routes } from "router/all_routes";

type Props = {
  dataSource: Payroll[];
  loading?: boolean;
  dataPaginate: any;
  onChange: (pg: any) => void;
};

const MyPayrollTable: React.FC<Props> = ({ 
  dataSource, 
  loading, 
  dataPaginate, 
  onChange 
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("payroll.form.period"),
      key: "period",
      align: "center" as const,
      render: (v: string, r: Payroll) => `${formatToLocaleDate(r.startDate)} - ${formatToLocaleDate(r.endDate)}`,
    },
    {
      title: t("payroll.form.gross_amount"),
      dataIndex: "grossAmount",
      key: "grossAmount",
      align: "center" as const,
      render: (amount: number) => formatMoney(amount),
    },
    {
      title: t("payroll.form.net_amount"),
      dataIndex: "netAmount",
      key: "netAmount",
      align: "center" as const,
      render: (amount: number) => formatMoney(amount),
    },
    {
      title: t("payroll.form.status"),
      dataIndex: "computedStatus",
      key: "computedStatus",
      align: "center" as const,
      render: (computedStatus: string) => (
        <PayrollStatusBadge status={computedStatus as any} />
      ),
    },
    {
      title: t("actions"),
      key: "actions",
      align: "center" as const,
      render: (v: string, r: Payroll) => {
        const actions: Action[] = [
          {
            label: t("payroll.form.view_details"),
            icon: "ti ti-eye",
            actionType: "link",
            to: all_routes.detailPayroll.replace(":idPayroll", r.id),
          },
        ];
        return <ActionsDropdown actions={actions} />;
      },
    },
  ];

  return (
    <div className="table-responsive">
      <Datatable
        rowKey="id"
        columns={columns}
        dataSource={dataSource ?? []}
        loading={loading}
        pagination={true}
        dataPaginate={dataPaginate}
        onChange={onChange}
      />
    </div>
  );
};

export default MyPayrollTable;